(() => {
  const init = () => {
    /**
     * @param {HTMLElement} carousel
     * @param {HTMLElement} track
     */
    const updateCarouselCountClass = (carousel, track) => {
      const count = track.querySelectorAll('.tnf-ww__product-card').length;
      carousel.classList.remove('tnf-ww--count-1','tnf-ww--count-2','tnf-ww--count-3');
      if (count >= 1 && count <= 3) {
        carousel.classList.add(`tnf-ww--count-${count}`);
      }
    };

    document.querySelectorAll('[data-ww-carousel]').forEach((/** @type {HTMLElement} */ carousel) => {
      const track = /** @type {HTMLElement|null} */ (carousel.querySelector('[data-ww-track]'));
      const prevBtn = /** @type {HTMLButtonElement|null} */ (carousel.querySelector('[data-ww-prev]'));
      const nextBtn = /** @type {HTMLButtonElement|null} */ (carousel.querySelector('[data-ww-next]'));
      if (!track || !prevBtn || !nextBtn) return;

      updateCarouselCountClass(carousel, track);

      const getScrollAmount = () => {
        const card = /** @type {HTMLElement|null} */ (track.querySelector('.tnf-ww__product-card'));
        return card ? card.offsetWidth + 16 : 300;
      };

      prevBtn.addEventListener('click', () => {
        const amount = -getScrollAmount();
        const before = track.scrollLeft;
        console.debug('WW: prev click', { before, amount, scrollWidth: track.scrollWidth, clientWidth: track.clientWidth });
        try {
          track.scrollBy({ left: amount, behavior: 'smooth' });
        } catch (e) {
          track.scrollLeft = before + amount;
        }
        setTimeout(() => {
          const after = track.scrollLeft;
          if (after === before) {
            track.scrollLeft = Math.max(0, before + amount);
            console.debug('WW: applied fallback scrollLeft', { before, after: track.scrollLeft });
          }
        }, 300);
      });

      nextBtn.addEventListener('click', () => {
        const amount = getScrollAmount();
        const before = track.scrollLeft;
        console.debug('WW: next click', { before, amount, scrollWidth: track.scrollWidth, clientWidth: track.clientWidth });
        try {
          track.scrollBy({ left: amount, behavior: 'smooth' });
        } catch (e) {
          track.scrollLeft = before + amount;
        }
        setTimeout(() => {
          const after = track.scrollLeft;
          if (after === before) {
            track.scrollLeft = Math.min(track.scrollWidth - track.clientWidth, before + amount);
            console.debug('WW: applied fallback scrollLeft', { before, after: track.scrollLeft });
          }
        }, 300);
      });

      const updateNavState = () => {
        const isScrollable = track.scrollWidth > track.clientWidth + 1; 
        prevBtn.disabled = !isScrollable;
        nextBtn.disabled = !isScrollable;
        if (!isScrollable) {
          prevBtn.setAttribute('aria-hidden', 'true');
          nextBtn.setAttribute('aria-hidden', 'true');
          carousel.classList.add('tnf-ww--nav-hidden');
        } else {
          prevBtn.removeAttribute('aria-hidden');
          nextBtn.removeAttribute('aria-hidden');
          carousel.classList.remove('tnf-ww--nav-hidden');
        }
      };

      /** @type {HTMLElement|null} */
      let dotsContainer = null;
      /** @type {number|null} */
      let scrollTimer = null;

      const getPages = () => {
        return Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth));
      };

      const renderDots = () => {
        const pages = getPages();
        if (!dotsContainer) {
          dotsContainer = document.createElement('div');
          dotsContainer.className = 'tnf-ww__products-dots';
          const carouselInner = carousel.querySelector('.tnf-ww__products-carousel');
          if (carouselInner) carouselInner.appendChild(dotsContainer);
        }
        // clear + create
        dotsContainer.innerHTML = '';
        for (let i = 0; i < pages; i++) {
          const btn = /** @type {HTMLButtonElement} */ (document.createElement('button'));
          btn.type = 'button';
          btn.className = 'tnf-ww__products-dot';
          btn.dataset.index = String(i);
          btn.setAttribute('aria-label', `Ir a página ${i + 1}`);
          if (i === 0) btn.classList.add('is-active');
          btn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#FFF" stroke="#FFF" stroke-width="2">
              <circle cx="12" cy="12" r="11" />
            </svg>
          `;
          btn.addEventListener('click', () => {
            track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
          });
          dotsContainer.appendChild(btn);
        }
        dotsContainer.style.display = pages > 1 ? '' : 'none';
      };

      const updateActiveDot = () => {
        if (!dotsContainer) return;
        const pages = getPages();
        const page = Math.round(track.scrollLeft / track.clientWidth);
        Array.from(dotsContainer.children).forEach((el, idx) => {
          el.classList.toggle('is-active', idx === page);
        });
        dotsContainer.style.display = pages > 1 ? '' : 'none';
      };

      track.addEventListener('scroll', () => {
        if (scrollTimer) window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => updateActiveDot(), 80);
      });


      const observer = new MutationObserver(() => {
        updateCarouselCountClass(carousel, track);
        updateNavState();
        renderDots();
      });
      observer.observe(track, { childList: true });
      updateNavState();
      window.addEventListener('resize', () => {
        updateNavState();
        renderDots();
        updateActiveDot();
      });
      renderDots();
      updateActiveDot();
    });

    document.querySelectorAll('[data-ww-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetId = btn.getAttribute('data-ww-toggle');
        if (!targetId) return;
        const target = document.getElementById(targetId);
        if (!target) return;
        const isOpen = target.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(isOpen));
        const textEl = /** @type {HTMLElement|null} */ (btn.querySelector('.tnf-ww__hero-toggle-text'));
        if (textEl) {
          textEl.textContent = isOpen ? textEl.dataset.textHide ?? '' : textEl.dataset.textShow ?? '';
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
